import { act_com } from '@lc/action/cardType/Common';
import { GameState } from '@lc/interface/gameState/types';

import { PR, PRVerbose } from './types';

export function createCardPR(
	id: number = -1,
	cost: number = 1,
	title: string = ``,
	flavor: string = ``
): PR {
	const type = 'PR';

	return {
		id,
		cost,
		type,
		title,
		flavor,
	};
}

export function createCardPRVerbose(pr: PR): PRVerbose {
	const action = (playerData: any, gameState: GameState) =>
		act_com.buyPrCard(playerData, gameState, pr.cost || 1);

	return {
		...pr,
		action,
	};
}
